// =============================================================================
// DATA / CATERING.JS — Calgary caterers
// Field order: Style/Specialty → Includes/Extras → Note → Phone → Email → Instagram → Website
// =============================================================================

export const cateringData = [
  { name: "Curated Catering by Hotel Arts", tier: "$$$", fields: [
    { label: "Style", value: "Exclusive caterer at SAIT — gourmet multi-course menus, bold flavours, artful presentation" },
    { label: "Phone", value: "403-210-5774" },
    { label: "Email", value: "SAITevents@hotelarts.ca" },
    { label: "Website", value: "curatedcatering.ca", link: "https://www.sait.ca/about-sait/campus/dining-on-campus/curated-catering" },
  ]},
  { name: "Alpine Catering", tier: "$/$$", fields: [
    { label: "Style", value: "Buffet and sit-down service; hot & cold food, hors d&apos;oeuvres" },
    { label: "Extras", value: "China, cutlery, wine glasses, linen serviettes, chair covers available" },
    { label: "Note", value: "Bartender service available on request" },
    { label: "Phone", value: "403-279-6664" },
    { label: "Email", value: "alpineca@telus.net" },
    { label: "Instagram", value: "@alpinecatering" },
    { label: "Website", value: "alpinecatering.ca", link: "https://www.alpinecatering.ca/" },
  ]},
  { name: "HT Catering & Meats", tier: "$/$$", fields: [
    { label: "Style", value: "Customizable packages, wide menu selection, professional serving team on-site" },
    { label: "Includes", value: "Signage, cutlery, and plates in all wedding packages" },
    { label: "Phone", value: "403-963-2107" },
    { label: "Email", value: "info@htcatering.ca" },
    { label: "Instagram", value: "@htcatering_meats" },
    { label: "Website", value: "htcatering.ca", link: "https://www.htcatering.ca/" },
  ]},
  { name: "Rocky Mountain BBQ", tier: "$", fields: [
    { label: "Style", value: "Fresh on-site BBQ — mobile, fully self-sustainable units" },
    { label: "Includes", value: "Serving tables, own power and water — completely self-contained" },
    { label: "Best For", value: "Outdoor and rustic venue weddings, casual celebrations" },
    { label: "Phone", value: "403-651-9926" },
    { label: "Email", value: "info@rockymountainbbq.ca" },
    { label: "Instagram", value: "@rockymountainbbqcatering" },
    { label: "Website", value: "rockymountainbbq.ca", link: "https://rockymountainbbq.ca/" },
  ]},
  { name: "Visionary Catering", tier: "$$", fields: [
    { label: "Style", value: "Flexible custom menus, advanced culinary skill, fresh locally sourced ingredients" },
    { label: "Phone", value: "403-264-7447" },
    { label: "Email", value: "order@visionarycatering.com" },
    { label: "Website", value: "visionarycatering.com", link: "https://www.visionarycatering.com/" },
  ]},
  { name: "Urbane Culinary", tier: "$$", fields: [
    { label: "Style", value: "Elevated hospitality — tailored menu planning, delivery, and full service" },
    { label: "Phone", value: "403-561-6478" },
    { label: "Email", value: "catering@urbaneculinary.ca" },
    { label: "Instagram", value: "@urbaneculinary" },
    { label: "Website", value: "urbaneculinary.ca", link: "https://urbaneculinary.ca" },
  ]},
  { name: "Devour Catering", tier: "$$/$$$ ", fields: [
    { label: "Style", value: "Full-service catering; can also serve as full wedding planner" },
    { label: "Extras", value: "Complimentary consultation; custom seasonal menus" },
    { label: "Phone", value: "403-242-0046" },
    { label: "Email", value: "devour@devourcatering.com" },
    { label: "Instagram", value: "@devourcateringyyc" },
    { label: "Website", value: "devourcatering.com", link: "https://devourcatering.com/events/weddings/" },
  ]},
  { name: "Black Salt Catering", tier: "$$", fields: [
    { label: "Style", value: "Customized creative menus; full-service, stress-free execution" },
    { label: "Phone", value: "587-353-3100" },
    { label: "Email", value: "info@blacksaltbistro.ca" },
    { label: "Instagram", value: "@blacksalt.calgary" },
    { label: "Website", value: "blacksaltbistro.ca", link: "https://blacksaltbistro.ca" },
  ]},
  { name: "Food Works Craft Catering", tier: "$$/$$$ ", fields: [
    { label: "Experience", value: "200+ weddings; serves Calgary, Central Alberta, and Western Canada" },
    { label: "Extras", value: "Complimentary tasting, full staffing, ProServe bar, vendor introductions" },
    { label: "Phone", value: "403-804-7775" },
    { label: "Email", value: "garret@food-works.ca" },
    { label: "Instagram", value: "@foodworksyyc" },
    { label: "Website", value: "food-works.ca", link: "https://www.food-works.ca" },
  ]},
];
